import React, { ReactElement, memo } from "react"
import { Grid, Typography, makeStyles, Divider } from "@material-ui/core"
import {
	DescriptionSize,
	AmountSize,
	ApplyGSTSize,
	ActionsSize,
} from "./__config/utilities"
import Spacer from "../Spacer/Spacer"

const useStyles = makeStyles((theme) => ({
	label: {
		fontWeight: theme.typography.fontWeightMedium,
		fontSize: theme.typography.fontSize,
		paddingBottom: "4px",
	},
}))

/**
 * Component to render the header of the form
 *
 * @export
 * @returns {ReactElement}
 */
export default memo(function FormHeader(): ReactElement {
	const cls = useStyles()

	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={DescriptionSize}>
					<Typography className={cls.label}>Naziv</Typography>
				</Grid>
				<Grid item xs={AmountSize}>
					<Typography className={cls.label}>Iznos</Typography>
				</Grid>
				<Grid item xs={ApplyGSTSize}>
					<Typography className={cls.label}>Uključi PDV</Typography>
				</Grid>
				<Grid item xs={ActionsSize}>
					<Typography className={cls.label}>Akcije</Typography>
				</Grid>
			</Grid>
			<Divider />
			<Spacer />
		</>
	)
})
